import dayjs from "dayjs";

export const FileHelper = {
  download({
    data,
    filename = dayjs().format("YYYYMMDDHHmmss"),
    extension = "xlsx",
  }: {
    data: BlobPart;
    filename?: string;
    extension?: string;
  }) {
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = `${filename}.${extension}`;
    link.click();
    link.remove();
  },
};
